import { useCallback } from 'react';
import { StatsExportType, useExportStatsMutation } from 'services/statsService';
import { saveBlob } from './useBiometricDownload';

/** Downloads a CSV of one stats type for the yyyy-MM-dd range `startDate`..`endDate`. */
export const useStatsDownload = (type: StatsExportType, startDate: string, endDate: string) => {
  const [exportStats, { isLoading, isError }] = useExportStatsMutation();

  const download = useCallback(async () => {
    try {
      const blob = await exportStats({ type, startDate, endDate }).unwrap();
      saveBlob(blob, `${type}_stats_${startDate}_${endDate}.csv`);
    } catch {
      // Surfaced through `isError`.
    }
  }, [exportStats, type, startDate, endDate]);

  return { download, isDownloading: isLoading, isError };
};
